document.addEventListener('DOMContentLoaded', () => {
  const nodeForm = document.getElementById('nodeApplicationForm');
  const workForm = document.getElementById('workApplicationForm');
  const nodeStatusEl = document.getElementById('nodeFormStatus');
  const workStatusEl = document.getElementById('workFormStatus');
  const workNodeSelect = document.getElementById('workNodeSelect');
  const workPositionSelect = document.getElementById('workPositionSelect');
  const workPositionDescription = document.getElementById('workPositionDescription');
  const popupEl = document.getElementById('applicationPopup');

  const nodeApplicationModal = document.getElementById('nodeApplicationModal');
  const workApplicationModal = document.getElementById('workApplicationModal');
  const membershipModal = document.getElementById('membershipModal');

  const showNodeBtn = document.getElementById('showNodeApplication');
  const showWorkBtn = document.getElementById('showWorkApplication');
  const becomeMemberBtn = document.getElementById('becomeMemberBtn');
  const closeNodeModalBtn = document.getElementById('closeNodeApplicationModal');
  const closeWorkModalBtn = document.getElementById('closeWorkApplicationModal');
  const closeMembershipModalBtn = document.getElementById('closeMembershipModal');

  const nodeMembershipError = document.getElementById('nodeMembershipError');
  const workMembershipError = document.getElementById('workMembershipError');

  const membershipStatusBlock = document.getElementById('membershipStatusBlock');
  const agreeMembership = document.getElementById('agreeMembership');
  const joinNetworkBtn = document.getElementById('joinNetworkBtn');
  const membershipMessage = document.getElementById('membershipMessage');
  const canvas = document.getElementById('signatureCanvas');
  const clearCanvasBtn = document.getElementById('clearCanvasBtn');

  const POPUP_MESSAGE = "Thats it! We'll reach out to you shortly to see if you are a good fit.";
  const MEMBER_REQUIRED_NODE = 'Become a member to apply to be a Node';
  const MEMBER_REQUIRED_WORK = 'Become a member to apply at this Node';

  let membership_state = { is_member: false, loaded: false };
  let hasDrawing = false;
  let drawCtx = null;
  let workNodesCache = [];
  const isSignedIn = () => Boolean(localStorage.getItem('lnf_token'));
  const showSignInGate = () => window.lnfAuthGate?.show?.();
  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  async function jsonFetch(url, options = {}) {
    const token = localStorage.getItem('lnf_token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(url, {
      ...options,
      headers: { ...headers, ...(options.headers || {}) }
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Request failed: ${response.status}`);
    }
    return response.status === 204 ? null : response.json();
  }

  const showPopup = (message) => {
    if (!popupEl) return;
    popupEl.textContent = message;
    popupEl.classList.remove('is-hidden');
    window.clearTimeout(showPopup._timer);
    showPopup._timer = window.setTimeout(() => {
      popupEl.classList.add('is-hidden');
    }, 4500);
  };

  const showModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-hidden');
  };

  const hideModal = (modal) => {
    if (!modal) return;
    modal.classList.add('is-hidden');
  };

  const showMembershipError = (target) => {
    if (!target) return;
    target.classList.remove('is-hidden');
  };

  const hideMembershipErrors = () => {
    nodeMembershipError?.classList.add('is-hidden');
    workMembershipError?.classList.add('is-hidden');
  };

  const openMembershipModal = async () => {
    showModal(membershipModal);
    await loadMembershipStatus();
  };

  const setMembershipStatusText = (text) => {
    if (membershipStatusBlock) membershipStatusBlock.textContent = text || '';
  };

  const loadMembershipStatus = async () => {
    const token = localStorage.getItem('lnf_token');
    if (!token) {
      membership_state = { is_member: false, loaded: true };
      setMembershipStatusText('Sign in on Profile first, then leave your drawn mark to become a member.');
      return membership_state;
    }
    try {
      const profile = await jsonFetch('/api/profile');
      const is_member = Boolean(profile?.is_member);
      membership_state = { is_member, loaded: true };
      if (is_member) {
        setMembershipStatusText('You are already a member and can apply now.');
        hideMembershipErrors();
      } else {
        setMembershipStatusText('You are not yet a member. Draw your mark and join below.');
      }
    } catch (_err) {
      membership_state = { is_member: false, loaded: true };
      setMembershipStatusText('Could not load membership status. Sign in on Profile, then try again.');
    }
    return membership_state;
  };

  const ensureMember = async (type) => {
    if (!isSignedIn()) {
      showSignInGate();
      if (type === 'node') {
        if (nodeMembershipError) nodeMembershipError.textContent = 'Sign in to apply to be a Node.';
        showMembershipError(nodeMembershipError);
      } else {
        if (workMembershipError) workMembershipError.textContent = 'Sign in to apply at this Node.';
        showMembershipError(workMembershipError);
      }
      return false;
    }
    if (!membership_state.loaded) await loadMembershipStatus();
    if (membership_state.is_member) return true;

    if (type === 'node') {
      if (nodeMembershipError) nodeMembershipError.textContent = MEMBER_REQUIRED_NODE;
      showMembershipError(nodeMembershipError);
    } else {
      if (workMembershipError) workMembershipError.textContent = MEMBER_REQUIRED_WORK;
      showMembershipError(workMembershipError);
    }
    return false;
  };

  showNodeBtn?.addEventListener('click', async () => {
    hideMembershipErrors();
    showModal(nodeApplicationModal);
    await loadMembershipStatus();
  });

  showWorkBtn?.addEventListener('click', async () => {
    hideMembershipErrors();
    showModal(workApplicationModal);
    await loadMembershipStatus();
  });

  becomeMemberBtn?.addEventListener('click', () => {
    openMembershipModal();
  });

  closeNodeModalBtn?.addEventListener('click', () => hideModal(nodeApplicationModal));
  closeWorkModalBtn?.addEventListener('click', () => hideModal(workApplicationModal));
  closeMembershipModalBtn?.addEventListener('click', () => hideModal(membershipModal));

  [nodeMembershipError, workMembershipError].forEach((el) => {
    el?.addEventListener('click', () => {
      openMembershipModal();
    });
  });

  [nodeApplicationModal, workApplicationModal, membershipModal].forEach((modal) => {
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) hideModal(modal);
    });
  });

  if (canvas) {
    drawCtx = canvas.getContext('2d');
    if (drawCtx) {
      canvas.style.touchAction = 'none';
      drawCtx.strokeStyle = '#ceb08d';
      drawCtx.lineWidth = 2;
      drawCtx.lineCap = 'round';

      let drawing = false;
      let lastX = 0;
      let lastY = 0;

      const getPos = (event) => {
        const rect = canvas.getBoundingClientRect();
        const scaleX = rect.width ? (canvas.width / rect.width) : 1;
        const scaleY = rect.height ? (canvas.height / rect.height) : 1;
        const point = event.touches && event.touches[0] ? event.touches[0] : event;
        return {
          x: (point.clientX - rect.left) * scaleX,
          y: (point.clientY - rect.top) * scaleY
        };
      };

      const startDraw = (event) => {
        event.preventDefault();
        drawing = true;
        const pos = getPos(event);
        lastX = pos.x;
        lastY = pos.y;
      };

      const draw = (event) => {
        if (!drawing) return;
        event.preventDefault();
        const pos = getPos(event);
        drawCtx.beginPath();
        drawCtx.moveTo(lastX, lastY);
        drawCtx.lineTo(pos.x, pos.y);
        drawCtx.stroke();
        hasDrawing = true;
        lastX = pos.x;
        lastY = pos.y;
      };

      const endDraw = (event) => {
        if (event) event.preventDefault();
        drawing = false;
      };

      if (window.PointerEvent) {
        canvas.addEventListener('pointerdown', startDraw);
        canvas.addEventListener('pointermove', draw);
        canvas.addEventListener('pointerup', endDraw);
        canvas.addEventListener('pointerleave', endDraw);
        canvas.addEventListener('pointercancel', endDraw);
      } else {
        canvas.addEventListener('mousedown', startDraw);
        canvas.addEventListener('mousemove', draw);
        canvas.addEventListener('mouseup', endDraw);
        canvas.addEventListener('mouseleave', endDraw);
        canvas.addEventListener('touchstart', startDraw, { passive: false });
        canvas.addEventListener('touchmove', draw, { passive: false });
        canvas.addEventListener('touchend', endDraw, { passive: false });
      }

      clearCanvasBtn?.addEventListener('click', () => {
        drawCtx.clearRect(0, 0, canvas.width, canvas.height);
        hasDrawing = false;
      });
    }
  }

  joinNetworkBtn?.addEventListener('click', async () => {
    if (membershipMessage) membershipMessage.textContent = '';

    if (!isSignedIn()) {
      showSignInGate();
      if (membershipMessage) membershipMessage.textContent = 'Sign in on Profile first, then return here to join.';
      return;
    }
    if (!agreeMembership?.checked) {
      if (membershipMessage) membershipMessage.textContent = 'You must agree to the Principles & Guidelines.';
      return;
    }
    if (!canvas || !hasDrawing) {
      if (membershipMessage) membershipMessage.textContent = 'Please draw your mark before joining.';
      return;
    }

    try {
      await jsonFetch('/api/profile', {
        method: 'POST',
        body: JSON.stringify({
          membership_mark: {
            mark_type: 'drawn',
            label: 'Drawn mark',
            value: null,
            data_url: canvas.toDataURL('image/png')
          }
        })
      });

      membership_state = { is_member: true, loaded: true };
      setMembershipStatusText('You are now a member and can apply.');
      hideMembershipErrors();
      if (membershipMessage) membershipMessage.textContent = 'Membership updated successfully.';
      hideModal(membershipModal);
    } catch (_err) {
      if (membershipMessage) membershipMessage.textContent = 'Failed to update membership.';
    }
  });

  const mapEl = document.getElementById('nodeMap');
  const mapList = document.getElementById('nodeMapList');
  const geoCacheKey = 'lnfNodeGeocodeCache';
  const GEO_CACHE_VERSION = 'v3';

  const normalizeAddressKey = (address) => {
    if (!address) return '';
    return address
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[.,]/g, '')
      .trim();
  };

  const buildAddressKey = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return `${normalizeAddressKey(value)}::${GEO_CACHE_VERSION}`;
    const parts = [
      value.street || '',
      value.city || '',
      value.state || '',
      value.zip || ''
    ].filter(Boolean).join(' ');
    return `${normalizeAddressKey(parts)}::${GEO_CACHE_VERSION}`;
  };

  const formatAddressParts = (value) => {
    if (!value) return '';
    const cityState = [value.city, value.state].filter(Boolean).join(', ');
    const stateZip = [value.state, value.zip].filter(Boolean).join(' ');
    if (value.city && value.state && value.zip) {
      return [value.street, value.city, stateZip].filter(Boolean).join(', ');
    }
    if (value.street && (value.city || value.state || value.zip)) {
      return [value.street, cityState || value.zip].filter(Boolean).join(', ');
    }
    return [value.street, value.city, value.state, value.zip].filter(Boolean).join(' ');
  };

  const getGeoCache = () => {
    try {
      return JSON.parse(localStorage.getItem(geoCacheKey) || '{}');
    } catch (_err) {
      return {};
    }
  };

  const saveGeoCache = (cache) => {
    try {
      localStorage.setItem(geoCacheKey, JSON.stringify(cache));
    } catch (err) {
      console.error('Unable to save geocode cache', err);
    }
  };

  const geocodeAddress = async (value) => {
    const cache = getGeoCache();
    const key = buildAddressKey(value);
    if (cache[key]) return cache[key];
    const params = new URLSearchParams({
      format: 'json',
      addressdetails: '1',
      limit: '1',
      countrycodes: 'us'
    });
    if (typeof value === 'string') {
      if (!value) return null;
      params.set('q', value);
    } else {
      if (!value) return null;
      const hasParts = Boolean(value.street || value.city || value.state || value.zip);
      if (!hasParts) return null;
      if (value.street) params.set('street', value.street);
      if (value.city) params.set('city', value.city);
      if (value.state) params.set('state', value.state);
      if (value.zip) params.set('postalcode', value.zip);
    }
    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`);
    if (!response.ok) return null;
    const results = await response.json();
    if (!results || !results.length) return null;
    const found = results[0];
    const coords = { lat: Number(found.lat), lng: Number(found.lon) };
    if (Number.isNaN(coords.lat) || Number.isNaN(coords.lng)) return null;
    cache[key] = coords;
    saveGeoCache(cache);
    return coords;
  };

  const loadNodeMap = async () => {
    if (!mapEl || !mapList) return;
    mapList.innerHTML = '<li>Loading nodes...</li>';
    if (typeof L === 'undefined') {
      mapList.innerHTML = '<li>Map library unavailable.</li>';
      return;
    }
    const mapParams = new URLSearchParams(window.location.search);
    const focusNodeId = String(mapParams.get('node_id') || '').trim();
    const focusQuery = String(mapParams.get('q') || '').trim().toLowerCase();

    const map = L.map(mapEl, { scrollWheelZoom: false });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);
    map.setView([39.5, -98.35], 4);

    let nodes = [];
    try {
      const response = await fetch('/api/nodes');
      nodes = response.ok ? await response.json() : [];
    } catch (err) {
      console.error('Failed to load nodes', err);
    }

    const getNodeCoords = (node) => {
      const lat = node.lat ?? null;
      const lng = node.lng ?? null;
      if (lat === null || lat === undefined || lng === null || lng === undefined) return null;
      const latNum = Number(lat);
      const lngNum = Number(lng);
      if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return null;
      return { lat: latNum, lng: lngNum };
    };

    const getNodeAddressParts = (node) => {
      const street = node.mailing_street || '';
      const city = node.mailing_city || '';
      const state = node.mailing_state || '';
      const zip = node.mailing_zip || '';
      if (!street && !city && !state && !zip) return null;
      return { street, city, state, zip };
    };

    const nodesWithLocation = (nodes || []).filter((node) => {
      const hasAddress = Boolean(node.mailing_address || getNodeAddressParts(node));
      return hasAddress || Boolean(getNodeCoords(node));
    });

    if (!nodesWithLocation.length) {
      mapList.innerHTML = '<li>No nodes with mailing addresses or coordinates yet.</li>';
      return;
    }

    const bounds = [];
    mapList.innerHTML = '';
    let focusedEntry = null;

    for (const node of nodesWithLocation) {
      const name = node.name || node.label || 'Node';
      const addressParts = getNodeAddressParts(node);
      const address = node.mailing_address || formatAddressParts(addressParts);
      const nodeId = String(node.id || '').trim();
      const searchBlob = [
        name,
        address,
        node.region,
        node.city,
        node.state,
        node.mailing_city,
        node.mailing_county,
        node.mailing_state
      ].filter(Boolean).join(' ').toLowerCase();
      const matchesById = Boolean(focusNodeId && nodeId && nodeId === focusNodeId);
      const matchesByQuery = Boolean(!matchesById && focusQuery && searchBlob.includes(focusQuery));
      const isFocused = matchesById || matchesByQuery;

      const listItem = document.createElement('li');
      listItem.textContent = `${name} - ${address || 'Coordinates on file'}`;
      if (nodeId) listItem.dataset.nodeId = nodeId;
      if (isFocused) {
        listItem.style.borderLeft = '3px solid #2f6f3e';
        listItem.style.background = 'rgba(47, 111, 62, 0.1)';
      }
      mapList.appendChild(listItem);
      if (isFocused && (!focusedEntry || matchesById || !focusedEntry.matchesById)) {
        focusedEntry = {
          listItem,
          marker: null,
          latLng: null,
          matchesById
        };
      }

      let coords = getNodeCoords(node);
      if (!coords && (addressParts || address)) {
        try {
          coords = await geocodeAddress(addressParts || address);
        } catch (err) {
          console.error('Geocode error for', address, err);
        }
      }

      if (!coords || Number.isNaN(coords.lat) || Number.isNaN(coords.lng)) continue;
      const latLng = [coords.lat, coords.lng];
      bounds.push(latLng);
      const marker = L.circleMarker(latLng, {
        radius: 6,
        color: '#c21313',
        fillColor: '#c21313',
        fillOpacity: 0.85
      })
        .addTo(map)
        .bindPopup(`<strong>${escapeHtml(name)}</strong><br>${escapeHtml(address)}`);

      if (isFocused && (!focusedEntry || matchesById || !focusedEntry.matchesById)) {
        focusedEntry = {
          listItem,
          marker,
          latLng,
          matchesById
        };
      } else if (isFocused && focusedEntry) {
        focusedEntry.marker = marker;
        focusedEntry.latLng = latLng;
      }
    }

    if (bounds.length) {
      map.fitBounds(bounds, { padding: [30, 30] });
    } else {
      map.setView([39.5, -98.35], 4);
    }

    if (focusedEntry) {
      focusedEntry.listItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (focusedEntry.latLng) {
        const zoom = Math.max(7, Number(map.getZoom() || 7));
        map.setView(focusedEntry.latLng, zoom);
      }
      if (focusedEntry.marker?.openPopup) focusedEntry.marker.openPopup();
      window.setTimeout(() => {
        focusedEntry.listItem.style.borderLeft = '';
        focusedEntry.listItem.style.background = '';
      }, 8000);
    }
  };

  const submitNodeApplication = async (payload) => {
    try {
      await jsonFetch('/api/nodes/applications', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      return true;
    } catch (err) {
      console.error('Failed to submit Node application:', err);
      return false;
    }
  };

  const submitWorkApplication = async (payload) => {
    try {
      await jsonFetch('/api/nodes/work-applications', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      return true;
    } catch (err) {
      console.error('Failed to submit work application:', err);
      return false;
    }
  };

  const normalizeNodePositions = (raw) => {
    if (!raw) return [];
    const source = Array.isArray(raw) ? raw : [];
    const seen = new Set();
    return source.reduce((acc, item) => {
      if (item === undefined || item === null) return acc;
      const titleRaw = typeof item === 'string'
        ? item
        : (item.title || item.position || item.name || item.label || '');
      const descriptionRaw = typeof item === 'string'
        ? ''
        : (item.description || item.summary || item.details || '');
      const title = String(titleRaw || '').trim();
      if (!title) return acc;
      const key = title.toLowerCase();
      if (seen.has(key)) return acc;
      seen.add(key);
      acc.push({
        title,
        description: String(descriptionRaw || '').trim()
      });
      return acc;
    }, []);
  };

  const updatePositionDescription = () => {
    if (!workPositionDescription || !workPositionSelect) return;
    const selected = workPositionSelect.selectedOptions?.[0];
    const desc = selected?.dataset?.description || '';
    if (desc) {
      workPositionDescription.textContent = desc;
      return;
    }
    if (!workPositionSelect.value) {
      workPositionDescription.textContent = 'Choose a node and then choose a position.';
      return;
    }
    workPositionDescription.textContent = '';
  };

  const renderPositionsForSelectedNode = () => {
    if (!workPositionSelect || !workNodeSelect) return;
    const selectedNodeId = workNodeSelect.value || '';
    const selectedNode = workNodesCache.find((node) => String(node.id || '') === String(selectedNodeId));
    const positions = normalizeNodePositions(selectedNode?.available_positions || []);

    workPositionSelect.innerHTML = '';
    if (!positions.length) {
      const fallback = document.createElement('option');
      fallback.value = 'General application';
      fallback.textContent = 'General application';
      fallback.dataset.description = 'This node has not listed open positions yet.';
      workPositionSelect.appendChild(fallback);
      workPositionSelect.disabled = false;
      if (workPositionDescription) {
        workPositionDescription.textContent = 'This node has not listed open positions yet.';
      }
      return;
    }

    const promptOption = document.createElement('option');
    promptOption.value = '';
    promptOption.textContent = 'Select a position';
    workPositionSelect.appendChild(promptOption);
    positions.forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.title;
      option.textContent = entry.title;
      if (entry.description) option.dataset.description = entry.description;
      workPositionSelect.appendChild(option);
    });
    workPositionSelect.disabled = false;
    updatePositionDescription();
  };

  const loadWorkNodes = async () => {
    if (!workNodeSelect) return;
    workNodeSelect.innerHTML = '<option value="">Loading nodes...</option>';
    let nodes = [];
    try {
      const response = await fetch('/api/nodes');
      nodes = response.ok ? await response.json() : [];
    } catch (err) {
      console.error('Failed to load nodes for work application', err);
    }

    const options = nodes.length ? nodes : [{ id: '', name: 'LostNFound Nursery' }];
    workNodesCache = options;
    workNodeSelect.innerHTML = '';
    options.forEach((node, idx) => {
      const option = document.createElement('option');
      option.value = node.id || '';
      option.textContent = node.name || node.label || `Node ${node.id || idx + 1}`;
      workNodeSelect.appendChild(option);
    });
    renderPositionsForSelectedNode();
  };

  if (nodeForm) {
    nodeForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (nodeStatusEl) nodeStatusEl.textContent = '';

      const canApply = await ensureMember('node');
      if (!canApply) return;

      const applicantName = nodeForm.querySelector('#nodeApplicantName')?.value.trim();
      const nodeName = nodeForm.querySelector('#nodeName')?.value.trim();
      const nodeServiceArea = nodeForm.querySelector('#nodeServiceArea')?.value.trim();
      const nodeOffers = nodeForm.querySelector('#nodeOffers')?.value.trim();
      const nodePhone = nodeForm.querySelector('#nodePhone')?.value.trim();

      const payload = {
        applicant_name: applicantName,
        node_name: nodeName,
        service_area: nodeServiceArea,
        node_offers: nodeOffers,
        node_phone: nodePhone,
        steward_name: applicantName,
        node_region: nodeServiceArea,
        node_contact: nodePhone,
        created_at: new Date().toISOString()
      };

      const sent = await submitNodeApplication(payload);
      if (sent) {
        nodeForm.reset();
        hideModal(nodeApplicationModal);
        showPopup(POPUP_MESSAGE);
      } else if (nodeStatusEl) {
        nodeStatusEl.textContent = 'Could not submit application right now. Please try again soon.';
      }
    });

    nodeForm.addEventListener('reset', () => {
      if (nodeStatusEl) nodeStatusEl.textContent = '';
    });
  }

  if (workForm) {
    workForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (workStatusEl) workStatusEl.textContent = '';

      const canApply = await ensureMember('work');
      if (!canApply) return;

      const applicantName = workForm.querySelector('#workApplicantName')?.value.trim();
      const nodeId = workForm.querySelector('#workNodeSelect')?.value || '';
      const nodeLabel = workForm.querySelector('#workNodeSelect')?.selectedOptions?.[0]?.textContent || '';
      const positionOption = workForm.querySelector('#workPositionSelect')?.selectedOptions?.[0] || null;
      const positions = positionOption?.value ? positionOption.value.trim() : '';
      const positionDescription = positionOption?.dataset?.description || '';
      const experience = workForm.querySelector('#workExperience')?.value.trim();
      const phone = workForm.querySelector('#workPhone')?.value.trim();

      if (!positions) {
        if (workStatusEl) workStatusEl.textContent = 'Select a position for this node.';
        return;
      }

      const payload = {
        applicant_name: applicantName,
        node_id: nodeId,
        node_name: nodeLabel,
        positions,
        position_title: positions,
        position_description: positionDescription,
        experience,
        phone,
        created_at: new Date().toISOString()
      };

      const sent = await submitWorkApplication(payload);
      if (sent) {
        workForm.reset();
        hideModal(workApplicationModal);
        showPopup(POPUP_MESSAGE);
      } else if (workStatusEl) {
        workStatusEl.textContent = 'Could not submit application right now. Please try again soon.';
      }
    });

    workForm.addEventListener('reset', () => {
      if (workStatusEl) workStatusEl.textContent = '';
      window.setTimeout(() => {
        renderPositionsForSelectedNode();
      }, 0);
    });
  }

  workNodeSelect?.addEventListener('change', () => {
    renderPositionsForSelectedNode();
  });

  workPositionSelect?.addEventListener('change', () => {
    updatePositionDescription();
  });

  loadMembershipStatus();
  loadNodeMap();
  loadWorkNodes();
});
